import styled from 'styled-components';
import Text from '../atoms/Text';
import WordBlock from './WordBlock';
import ExpandedSection from './ExpandedSection';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import { formatTime } from '../../utils/formatTime';

const Wrapper  = styled.div`
  width: 100%;
`
const SpeakerBox = styled.div`
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  // width: 100%;
`
const Speaker = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`
const Marker = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${({ $isChild, theme }) => $isChild ? theme.colors.secondary : theme.colors.primary};
  display: flex;
  justify-content: center;
  align-items: center;
`
const PlayIcon = styled(PlayArrowRoundedIcon)`
  color: ${(props) => props.theme.colors.primary};
`
const TimeStampButton = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
  cursor: pointer;
  padding: 0;
  margin: 0;
  background: none;
  border: none;
  font-variant-numeric: tabular-nums;
`
const WordsWrapper = styled.div`
  padding: 0 20px;
  display: flex;
  column-gap: 4px; // 가로 간격
  row-gap: 8px; // 세로 간격
  flex-wrap: wrap
`
const TextWrapper = styled.div`
  padding: 0 20px;
`

const ConversationBlock = ({ hrId, $isEditable, item, parentIdx, expandedIdx, toggleExpand, newMeanings, onMeaningChange, onAddMeaningClick, onRemoveAddedMeaning, onHelpClick, onSeek }) => {
  const isChild = item.speaker === true;
  const wordPropsList = item.content.map((word) => {
    const childIdx = word.wordSerialNum;
    const key = `${parentIdx}-${childIdx}`
    const meaningState = newMeanings[key] || {};
    
    const isLowConfidence = word.rate && word.rate.length > 0 && word.rate[0].rate < 0.7;
    const initialMeaning = isLowConfidence ? null : word.meaning;
    
    return {
      key: key,
      drId: word.id,
      content: word.content,
      meaning: word.meaning,
      rate: word.rate,
      selectedMeaning: meaningState?.selectedMeaning === null
        ? null
        : meaningState?.selectedMeaning ?? initialMeaning,
      addedMeaning: meaningState.addedMeaning || null,
    };
  });
  
  const expandedWord = wordPropsList.find((item, idx) => item.key === expandedIdx);

  return (
    <Wrapper>
      <SpeakerBox>
        <Speaker>
          <Marker $isChild={isChild}>
            <Text weight="medium" color="inverse">
              {isChild ? 'C' : 'G'}
            </Text>
          </Marker>
          <Text weight="medium">{isChild ? '아동화자' : '일반화자'}</Text>
        </Speaker>
        
        <TimeStampButton onClick={() => onSeek(item.startTime)}>
          <PlayIcon sx={{ fontSize: 16 }}/>
          <Text variant="body2" color="alternative">
            {formatTime(item.startTime, 'ms')}
          </Text>
        </TimeStampButton>  
      </SpeakerBox>
      {isChild ? (
        <>  
          <WordsWrapper>
            {wordPropsList.map((word, wordIdx) => (
              <WordBlock
                $isEditable={$isEditable}
                word={word}
                key={word.key}
                onToggle={() => toggleExpand(word.key)}
                selectedMeaning={word.selectedMeaning}
                $isActive={expandedIdx === word.key}
              />
            ))}
          </WordsWrapper>
          {$isEditable && expandedWord &&
            <ExpandedSection
              hrId={hrId}
              drId={expandedWord.drId}
              word={expandedWord} 
              rates={expandedWord.rate}
              onMeaningChange={onMeaningChange}
              onAddMeaningClick={() => onAddMeaningClick(expandedWord)}
              onRemoveAddedMeaning={onRemoveAddedMeaning}
              onHelpClick={onHelpClick}
            />}
        </>
      ) : (
        <TextWrapper>
          <Text>{item.content[0].content}</Text>
        </TextWrapper>
      )}
    </Wrapper>
  )
}

export default ConversationBlock
